import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "react-router";
import NotificationsList from "notifications/containers/list";
import Icon from "common/components/svg_icon";
import { EXPIRATION_IN_DAYS } from "notifications/constants";

class Drawer extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { userId, markAllAsSeen, showDrawer } = this.props;
    if (!nextProps.hide && !showDrawer && nextProps.showDrawer) {
      markAllAsSeen(userId);
    }
  }

  render() {
    const { showDrawer, toggleDrawer, hide, clearAll, userId } = this.props;

    if (hide) {
      return null;
    }

    const classes = classnames("notification-drawer", { open: showDrawer });

    return (
      <div className={classes}>
        <div className="notifications-drawer-container">
          <div className="notifications-drawer-header">
            <div className="row collapse">
              <div className="small-8 columns">
                <button
                  className="btn btn-icon-only btn-close"
                  onClick={toggleDrawer}
                >
                  <Icon icon="close" />
                </button>
                <h4>Notifications</h4>
              </div>
            </div>
            <div className="expiration-notice">
              Notifications are deleted after {EXPIRATION_IN_DAYS} days.
            </div>
            <ul className="notification-links">
              <li>
                <a onClick={() => clearAll(userId)}>Clear all</a>
              </li>
              |
              <li>
                <Link to="/notifications/">View all</Link>
              </li>
              |
              <li>
                <Link to="/account/notifications/">Settings</Link>
              </li>
            </ul>
          </div>
          <NotificationsList
            filter={({ cleared }) => !cleared}
            emptyMessage="All caught up!"
            grouped={true}
            showClear={true}
          />
        </div>
      </div>
    );
  }
}

Drawer.propTypes = {
  hide: PropTypes.bool,
  showDrawer: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  markAllAsSeen: PropTypes.func.isRequired,
  userId: PropTypes.number,
  clearAll: PropTypes.func.isRequired,
};

export default Drawer;
